module.exports = __webpack_public_path__ + "static/Big Sky Health-fe0899d45c4ec919419145a84efb10fd.jpg";